import React, { useEffect } from "react";
import { connect } from 'react-redux'
import { SketchPicker, Color } from "react-color";
import { Button, Row, Col } from "reactstrap";
import { colorHelper } from "../../../helpers/colorHelper";
import Popover from "@material-ui/core/Popover";
import { cmsActions } from "../../../store/actions/cms/cms.action";
import TemplateColors from "./TemplateColors";


const ColorPickerFacade = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
        props.dispatch(cmsActions.blockDeselect(true))
        //load all colors from template
    };
    const handleClose = () => {
        setAnchorEl(null);
        setTimeout(() => props.dispatch(cmsActions.blockDeselect(false)), 2000)
    };

    const { color, onChange, path } = props;
    const open = Boolean(anchorEl);
    const id = open ? `${path.replace(".", "-")}` : undefined;
    return (
        <React.Fragment>
            <Row style={{ margin: '0px' }}>
                <Col style={{ textAlign: 'right', padding: '0px' }}>
                    <Button
                        onClick={handleClick}
                        style={{
                            backgroundColor: color,
                            border: "2px solid rgb(224, 224, 224)",
                            borderRadius: "0.25rem",
                            width: '40px',
                            color: color && colorHelper.getCorrectTextColor(color),
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            maxWidth: '126px',
                            fontFamily: 'unset',
                            minHeight: '30px',
                    
                            opacity: color == 'unset' ? 0.3 : 1,
                            background: color == 'unset' ? 'url(https://upload.wikimedia.org/wikipedia/commons/thumb/7/70/Checkerboard_pattern.svg/1200px-Checkerboard_pattern.svg.png)' : color,
                            backgroundSize: color == 'unset' ? 'cover' : undefined,

                        }}
                    >
                    </Button>
                    <React.Fragment>
                        <Popover
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            style={{ zIndex: 10000, padding: "10px" }}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "center"
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "center"
                            }}
                        >
                            <SketchPicker
                                color={color}

                                disableAlpha={false}
                                onChangeComplete={(color, e) =>
                                    onChange(color, e, path)
                                }
                            />
                            <TemplateColors path={path} onClick={onChange} />
                        </Popover>
                    </React.Fragment>
                </Col>
            </Row>
        </React.Fragment >
    );
};
function mapStateToProps(state) {
    return {
        usedColors: state.template.usedColors
    };
}
export default connect(mapStateToProps)(ColorPickerFacade);